<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-email-send</v-icon>
                <p style="color: white;">Enviar Documentos </p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text class="pa-5 pt-4">
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader
                                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" md="7">
                            <div v-for="(item, index) in extraDataItems" :key="index" class="mt-1">
                                <div id="texFieldType" v-if="item.tipoInput == 'textfield'">
                                    <span class="type-label-style">{{ item.txtLabel }}</span>
                                    <v-text-field v-on:blur="
                                        dynamicVModels[index].valor =
                                        dynamicVModels[index].valor.trim()
                                        " :rules="dynamicRulesGen(item)"
                                        :type="extraDataItems[index].textType != undefined ? extraDataItems[index].textType : 'text'"
                                        solo v-model="dynamicVModels[index].valor">
                                    </v-text-field>
                                </div>
                                <div id="mailTextField" v-if="item.tipoInput == 'mailTextfield'">
                                    <span class="type-label-style">{{ item.txtLabel }}</span>
                                    <v-autocomplete solo chips clearable deletable-chips :rules="dynamicRulesGen(item)"
                                        :items="dynamicVModels[index].items" v-model="dynamicVModels[index].valor"
                                        :search-input.sync="dynamicVModels[index].searchIteam"
                                        no-data-text="Introduzca un correo válido"
                                        @change="resetItemsSelector($event, item, index)"
                                        @keyup="addMailValider($event, item, index)"></v-autocomplete>
                                    <v-chip class="ma-2" close color="#536DFE" dark v-for="(chips, chipIndex) in dynamicVModels[index]
                                        .selectedItems" :key="chipIndex" @click:close="deleteFromList(index, chips)">
                                        {{ chips }}
                                    </v-chip>
                                </div>
                                <div id="selectType" v-if="item.tipoInput == 'selectCorreos'">
                                    <div style="height: 22px"></div>
                                    <v-select solo :rules="dynamicRulesGen(item)" v-model="dynamicVModels[index].valor"
                                        :items="dynamicVModels[index].opciones" item-text="descripcion"
                                        item-value="valorZona" @change="
                                            newSelectedMails(dynamicVModels[index].valor, index - 1)
                                            "></v-select>
                                </div>
                                <div id="areaType" v-if="item.tipoInput == 'textarea'">
                                    <span class="type-label-style">{{ item.txtLabel }}</span>
                                    <v-textarea v-on:blur="
                                        dynamicVModels[index].valor =
                                        dynamicVModels[index].valor.trim()
                                        " :rules="dynamicRulesGen(item)" v-model="dynamicVModels[index].valor"
                                        class="mt-1" outlined></v-textarea>
                                </div>
                                <div id="TODO_other"></div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                    <v-row justify="center" class="mb-8">
                        <v-btn class="ma-2" color="#536DFE" :disabled="disabledSave" style="color:white"
                            @click="Guardar()">Guardar</v-btn>
                        <v-btn class="ma-2" color="default" :disabled="disabledSave" @click="limpiar()">Limpiar</v-btn>
                        <v-btn class="ma-2" color="error" :disabled="disabledSave" @click="Cancelar()">Cancelar</v-btn>
                    </v-row>
                </v-card-actions>
            </v-form>
        </v-card>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import Archivos from '@/services/Archivos/Archivos.service.js';
import utils from '@/utils/managerLocalStorage.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";
export default {
    title() {
        return this.$route.meta.title
    },
    data: function () {
        return {
            validForm: true,
            disabledSave: false,
            counterDanger: false,

            //
            extraDataItems: [],
            dynamicVModels: [],
            mailSelected: 0,
            tempMails: [],
            loaded: false,
            datos: null
        }
    },
    props: [],
    computed: {
        ...mapState([
            "domain",
            "informationPage",
            "paginacion",
            "permission",
            "user"
        ])
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        resetItemsSelector(event, item, listIndex) {
            if (this.dynamicVModels[listIndex].valor != null) {
                this.mailSelected++;
                this.dynamicVModels[listIndex].selectedItems.push(this.dynamicVModels[listIndex].valor);
                this.dynamicVModels[listIndex].searchIteam = null;
                this.dynamicVModels[listIndex].items = null;
            }
        },
        deleteFromList(index, item) {
            this.dynamicVModels[index].selectedItems = this.dynamicVModels[index].selectedItems.filter((element) => element !== item);
            if (this.dynamicVModels[index].selectedItems.length == 0) {
                this.dynamicVModels[index].valor = null;
            }
        },
        async newSelectedMails(value, listIndex) {
            this.mailSelected++;
            let correosResponse = await reporteExpJur.obtenerCorreosPorZona(this, value);
            if (this.tempMails.length > 0) {
                this.dynamicVModels[listIndex].selectedItems = this.dynamicVModels[
                    listIndex
                ].selectedItems.filter((item) => !this.tempMails.includes(item));
            }
            correosResponse.data.forEach((element) => {
                this.tempMails.push(element.correo);
                this.dynamicVModels[listIndex].selectedItems.push(element.correo);
            });
        },
        dynamicRulesGen(item) {
            var resultRules = [];
            try {
                if (item.required == "SI") {
                    resultRules.push((v) => !!v || "Campo requerido");
                }
                if (item.regex != null) {
                    if (item.idNombre != "tCorreoCopia") {
                        resultRules.push(
                            (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
                        );
                    }
                }
            } catch (e) {
            }
            return resultRules;
        },
        addMailValider(event, item, listIndex) {
            if (RegExp(item.regex).test(this.dynamicVModels[listIndex].searchIteam) == true) {
                this.dynamicVModels[listIndex].items = [
                    {
                        value: this.dynamicVModels[listIndex].searchIteam,
                        text: this.dynamicVModels[listIndex].searchIteam,
                    },
                ];
            }
        },

        Cancelar() {
            this.$router.go(-1);
        },
        async Guardar() {
            this.$refs.form.validate()
            if (this.$refs.form.validate()) {
                let movimientoBody = {};
                this.dynamicVModels.forEach((element) => {
                    if (element.selectedItems != undefined && element.selectedItems != null) {
                        movimientoBody[element.textLabel] = element.selectedItems.toString();
                    }
                    if (element.valor != undefined || element.valor != null) {
                        if ((element.textLabel == "tCorreoCopia" || element.textLabel == "tCorreoPara") && element.selectedItems.length > 0) {
                            movimientoBody[element.textLabel] = element.selectedItems.join(";");
                        } else {
                            movimientoBody[element.textLabel] = element.valor;
                        }
                    }
                });
                let para_string = "Para: " + movimientoBody.tCorreoPara;
                let ladestinatariocc = movimientoBody.tCorreoCopia == "" ? '' : ' CCO: ' + movimientoBody.tCorreoCopia;
                let destinatario = para_string + ladestinatariocc;
                this.$swal({
                    title: 'Procesando solicitud',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let correo = await Archivos.EnviarCorreo(this.datos, movimientoBody);
                        if (correo == "") {
                            let doc = await MetodosGenerales.obtenerSessionReporte('documento');
                            var datosReporte = new FormData();
                            datosReporte.append("nrreporte", this.datos.nrreporte);
                            datosReporte.append("svindice", this.datos.svindice);
                            var formData = new FormData();
                            formData.append("lasitio", 'Prusia+');
                            formData.append("lomodulo", "Documentos");
                            formData.append("laaccion", "Enviar Correo");
                            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                            formData.append("lanombre", doc.docarchivo);
                            formData.append("ladestinatario", destinatario);
                            Archivos.AlmacenarVisitas(formData);
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: "El correo se ha enviado exitosamente",
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 2500,
                            }).then(async () => {
                                this.$router.go(-1);
                            });
                        } else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: 'Error',
                                text: "Ocurrio un erro al enviar el correo, intentelo de nuevo",
                                showConfirmButton: false,
                                timer: 2500
                            });
                        }
                    }

                });
            }
        },
        async ObtenerDatos() {
            let correo = await Archivos.ValidacionEnvioCorreo(this.datos);
            if (correo.puedeMandarCorreo == false) {
                this.$swal({
                    position: "center",
                    icon: "error",
                    title: "Error en envio de correo",
                    text: `El archivo adjunto pesa ` + correo.tamaño + `MB y el limite es de 5 MB, intente comprimir el archivo y enviarlo por partes`,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    timer: 2500,
                }).then(() => {
                    this.$router.go(-1);
                });
            }
        },
        async ObtenerFormulario() {
            let form = await Archivos.ObtenerFormulario(this);
            console.log("el formulario: ", form);
            this.extraDataItems = form.inputs;
            this.extraDataItems.forEach((element) => {
                let body = {
                    textLabel: element.idNombre,
                    valor: "",
                };
                if (element.tipoInput.toString().toLowerCase() == "mailtextfield") {
                    body.searchIteam = "";
                    body.items = [];
                    body.selectedItems = [];
                }
                if (
                    element.tipoInput.toString().toLowerCase() == "select" ||
                    element.tipoInput.toString().toLowerCase() == "selectcorreos"
                ) {
                    body.opciones = element.opciones;
                }
                if (element.txtLabel == 'Para...:') {
                    element.txtLabel = 'Para:'
                }
                if (element.txtLabel == 'CC...:') {
                    element.txtLabel = 'CC:'
                }
                this.dynamicVModels.push(body);
            });
            this.loaded = true;
        },
        async limpiar() {
            await this.$refs.form.reset();
            this.dynamicVModels.forEach((element) => {
                if ((element.textLabel == "tCorreoCopia" || element.textLabel == "tCorreoPara") && element.selectedItems.length > 0) {
                    element.selectedItems = [];
                }
            });
        }
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.changeReporteMenuOption('NoView');
        await this.ObtenerDatos();
        this.ObtenerFormulario();
    }
}
</script>

<style scoped>
.type-label-style {
    font-family: "Roboto", sans-serif;
    font-weight: 400;
    font-size: 14px;
}
</style>